import { useEffect, useState, useMemo, useCallback } from 'react';
import { Location } from 'react-router';
import { Outlet, useLocation, useMatch } from 'react-router';
import { Loader } from 'components/Loader/Loader';
import NotFound from 'pages/NotFound';
import { SITE_ROUTE_PATH } from 'utils/constants';
import { useHintContext } from 'utils/contexts/HintContext';
import { useSiteContext } from 'utils/contexts/SiteContext';
import { SiteState } from 'utils/hooks/useSiteState';

type LocationState = Omit<Location, 'state'> & {
    state: {
        site?: Partial<SiteState>;
    };
};

export const SiteRoute = () => {
    const { site, updateSite } = useSiteContext();
    const { siteHints } = useHintContext();
    const { state }: LocationState = useLocation();
    const [siteExists, setSiteExists] = useState<boolean>();

    const params = useMatch(SITE_ROUTE_PATH)?.params;
    const { siteId: paramSiteId } = params || {};

    useEffect(() => {
        const siteState = { site_id: Number(paramSiteId), ...state?.site };
        updateSite(siteState).then(setSiteExists);

        return () => {
            updateSite(undefined);
        };
        // TODO: Add state.site back as a dependency
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paramSiteId, updateSite]);

    if (siteExists === false) {
        return <NotFound />;
    }

    if (site && siteHints) {
        return <Outlet />;
    }

    return <Loader />;
};
